import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

import _get from 'lodash/get';
import { useSelector } from 'react-redux';

import { getLocationTitlePrompt } from './LocationTitleField.utils';
import ErrorHandler from '../../../../libs/errors';
import { selectBusinessId, selectBusinessType } from '../../../../selectors';
import ActionsInput from '../../../modules/content/components/ActionsInput';
import WritingAssistantButton from '../../../modules/content/components/WritingAssistantButton';
import { getWritingAssistantActions } from '../../../modules/content/services/prompts';

import './LocationTitleField.scss';

const propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const defaultProps = {
  value: '',
  locationId: null,
};

export default function LocationTitleField({ value, onChange, locationId }) {
  const businessId = useSelector(selectBusinessId);
  const businessType = useSelector(selectBusinessType);
  const [loading, setLoading] = useState(false);

  async function onMakeSuggestion() {
    try {
      setLoading(true);
      const params = { location_id: locationId };
      const { text_completion: generatedTitle } = await getLocationTitlePrompt(
        businessType,
        businessId,
        params,
      );
      return generatedTitle || '';
    } catch (error) {
      ErrorHandler.capture(error);
      return '';
    } finally {
      setLoading(false);
    }
  }

  function onTitleChange(e, target) {
    const newValue = _get(target, 'value', target || e);
    onChange(newValue);
  }

  return (
    <ActionsInput className="location-title-field">
      <ActionsInput.Input
        input={Input}
        value={value}
        onChange={onTitleChange}
        placeholder="Location title"
        disabled={loading}
        loading={loading}
      />

      <ActionsInput.Actions
        trigger={WritingAssistantButton}
        actionSections={getWritingAssistantActions({ onMakeSuggestion })}
        intelligentWebsiteOnly
        disabled={loading || !locationId}
      />
    </ActionsInput>
  );
}

LocationTitleField.propTypes = propTypes;
LocationTitleField.defaultProps = defaultProps;
